"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const react_1 = require("react");
const SvgWarningIcon12Px = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 12, height: 12, fill: "none" }, props),
    React.createElement("path", { fill: "#FECA63", d: "M5.11 1.492a1 1 0 0 1 1.78 0l4.116 8.053a1 1 0 0 1-.89 1.455H1.884a1 1 0 0 1-.89-1.455L5.11 1.492Z" }),
    React.createElement("path", { fill: "#333", fillRule: "evenodd", d: "M6.5 9v1h-1V9h1Zm0-6v5h-1V3h1Z", clipRule: "evenodd" })));
const Memo = (0, react_1.memo)(SvgWarningIcon12Px);
exports.default = Memo;
//# sourceMappingURL=WarningIcon12Px.js.map